import React, { useState } from 'react'
import FeedbackSat from './FeedbackSat'
import FeedbackUnsat from './FeedbackUnsat'
import clinicService from '../../services/clinic.service'

const Feedback = ({ clinic, patientID }) => {
  const [satisfaction, setSatisfaction] = useState(null)
  const [step, setStep] = useState('rate')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleNext = () => {
    if (!satisfaction || submitting) return

    setSubmitting(true)
    setError(null)

    clinicService
      .addFeedback(clinic.ID, {
        patientID,
        feedback: satisfaction === 'satisfied' ? 2 : 1,
      })
      .then(() => {
        setStep(satisfaction === 'satisfied' ? 'satisfied' : 'unsatisfied')
      })
      .catch(() => {
        setError('Something went wrong. Please try again.')
      })
      .finally(() => setSubmitting(false))
  }

  if (step === 'satisfied') {
    return <FeedbackSat clinic={clinic} />
  }

  if (step === 'unsatisfied') {
    return <FeedbackUnsat clinic={clinic} patientID={patientID} />
  }

  return (
    <section className="rep-panel">
      <p className="rep-kicker">Your visit</p>
      <h2 className="rep-title">How was your experience?</h2>
      <p className="rep-copy">
        Thank you for sharing feedback about your recent visit with {clinic.name}.
        Your response helps us improve care for every patient.
      </p>

      <div className="rep-choices" role="radiogroup" aria-label="Satisfaction">
        <button
          type="button"
          role="radio"
          aria-checked={satisfaction === 'satisfied'}
          className={`rep-choice rep-choice--good${satisfaction === 'satisfied' ? ' is-selected' : ''}`}
          onClick={() => setSatisfaction('satisfied')}
        >
          <span className="rep-choice-icon" aria-hidden="true">
            <i className="bi bi-hand-thumbs-up" />
          </span>
          <span>
            <span className="rep-choice-label">Satisfied</span>
            <span className="rep-choice-hint">Everything went well</span>
          </span>
        </button>

        <button
          type="button"
          role="radio"
          aria-checked={satisfaction === 'unsatisfied'}
          className={`rep-choice rep-choice--bad${satisfaction === 'unsatisfied' ? ' is-selected' : ''}`}
          onClick={() => setSatisfaction('unsatisfied')}
        >
          <span className="rep-choice-icon" aria-hidden="true">
            <i className="bi bi-hand-thumbs-down" />
          </span>
          <span>
            <span className="rep-choice-label">Unsatisfied</span>
            <span className="rep-choice-hint">Something could improve</span>
          </span>
        </button>
      </div>

      {error ? <p className="rep-error">{error}</p> : null}

      <div className="rep-actions">
        <button
          type="button"
          className="rep-btn rep-btn--primary"
          onClick={handleNext}
          disabled={!satisfaction || submitting}
        >
          {submitting ? 'Submitting…' : 'Continue'}
        </button>
      </div>
    </section>
  )
}

export default Feedback
